type EventType = 'load' | 'interaction' | 'error' | 'render'
interface AnalyticsEventDetail {
	data?: unknown
	type?: EventType
}

/**
 * Dispatches a custom event for analytics listeners.
 * @param namespace Namespace in which the event takes place.
 * *E.g. 'q' for Quantum, 'gbpe' for Global Portable Experiences, 'oc' for Owner Center, and 'ma' for My Account*
 * @param componentName Name of the component that the event occurred from camel case. *E.g. 'userProfile'*
 * @param eventName Name of the event in camel case. *E.g. 'profileLoaded'*
 * @param type What kind of event happened. Pass in `null` if no `type` is needed but you want to pass in `data`.
 * @param data Payload to send to analytics software.
 */
export function fireAnalyticsEvent(
	namespace: 'q' | 'gbds' | 'gbpe' | 'oc' | 'ma',
	componentName: string,
	eventName: string,
	type?: EventType,
	data?: unknown
): void {
	const name = `${namespace}-${componentName}-${eventName}`
	const detail: AnalyticsEventDetail = { data, type }
	const customEvent = new CustomEvent(name, { detail })
	document.dispatchEvent(customEvent)
}
